import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/lib/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: '#624DE3',//,'#0AAF60',
        // success : '#C4E6BF'
        // info : '#97F2F9'
        // secondary: '#b0bec5',
        accent: '#8c9eff',
        // error: '#b71c1c',
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
});
